const ContentImage = ({image}) => {
  return (
    <div>
        <img style={{ width: '100%'}} src={process.env.REACT_APP_PUBLIC_STORAGE+image} />
      </div>
  )
}
export default ContentImage